<cbs-parent-subcategory [optionColumnLayout]="optionColumnLayout" [singleColumnProperty]="singleColumnProperty"
                        *ngIf="parentSubcategory$ | async as parentSubcategory" [includeSearch]="cosSearchFilter$|async"
                        [parentSubcategory]="parentSubcategory" [fieldContainer]="fieldContainer"
                        [footerTemplate]="footerTemplate"></cbs-parent-subcategory>
